import { authGet, authPost } from '../http_client.js';
import type { ClaimHeartGiftsDto, ClaimInviteRewardsDto, FriendsListDto, InviteSummaryDto, RemindFriendDto, SendHeartDto } from '../dto/friends.dto.js';

export function getInvite(): Promise<InviteSummaryDto>
{
  return authGet<InviteSummaryDto>( 'api/player/me/invite' );
}

export function claimInviteRewards(): Promise<ClaimInviteRewardsDto>
{
  return authPost<ClaimInviteRewardsDto>( 'api/player/me/invite/claim' );
}

export function getFriends(): Promise<FriendsListDto>
{
  return authGet<FriendsListDto>( 'api/player/me/friends' );
}

export function sendHeart( friend_id: number ): Promise<SendHeartDto>
{
  return authPost<SendHeartDto>( `api/player/me/friends/${friend_id}/send-heart` );
}

export function remindFriend( friend_id: number ): Promise<RemindFriendDto>
{
  return authPost<RemindFriendDto>( `api/player/me/friends/${friend_id}/remind` );
}

export function dismissReminder( friend_id: number ): Promise<unknown>
{
  return authPost<unknown>( `api/player/me/friends/${friend_id}/remind/dismiss` );
}

export function claimHeartGifts( gift_ids: string[] ): Promise<ClaimHeartGiftsDto>
{
  return authPost<ClaimHeartGiftsDto>( 'api/player/me/friends/gifts/claim', { gift_ids } );
}
